<template>
  <div></div>
</template>

<script>
import moment from 'moment'
import { RESOURCES } from '@batimentb/vadimm-js-api'
export default {
  name: 'RedirectByRdv',
  async created () {
    try {
      let { data } = await this.$api.getOne(RESOURCES.RDV, this.$route.query.pk)
      let reminder = data
      let day = moment(reminder.date).format('DD')
      let month = moment(reminder.date).format('MM')
      let year = moment(reminder.date).format('YYYY')
      this.$router.push({ name: 'CalendarDay', params: { year, month, day, panel: 'rdvs' } })
    } catch (error) {
      if (error.response.status === 404) {
        this.$router.push({ name: '404' })
      } else {
        this.$toasted.global.danger('Une erreur inattendue s\'est produite.')
      }
    }
  }
}
</script>
